var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShipping(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "encomiendas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 22.5,
    viewBox: "0 0 30 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 30,
    height: 22.5,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 21.887,
    height: 21.829,
    fill: "#85af26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17",
    "data-name": "Mask Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(4.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M21.886,5.89a.734.734,0,0,0-.465-.742C18.457,3.674,15.251,2.071,11.333.1A.777.777,0,0,0,10.565.1C7.3,1.739,3.971,3.4.389,5.188A.645.645,0,0,0,0,5.833C.005,7.1,0,8.4,0,9.647v2.489c0,1.271,0,2.586,0,3.879a.628.628,0,0,0,.387.623c3.525,1.757,6.95,3.47,10.179,5.092a.838.838,0,0,0,.38.1.809.809,0,0,0,.367-.1c3.68-1.847,6.994-3.5,10.133-5.066a.709.709,0,0,0,.438-.712c-.009-3.537-.009-6.83,0-10.065M11.439,11.377c0-.127.01-.165.109-.214C14,9.941,16.5,8.694,18.907,7.488l1.942-.971.033-.016V8.077q0,3.8,0,7.593c0,.129-.013.168-.108.215-2.468,1.228-4.974,2.481-7.4,3.693l-1.928.964-.009,0V18.983q0-3.8,0-7.606m8.83-5.684-.032.016-1.922.961Q14.7,8.478,11.083,10.289a.252.252,0,0,1-.27,0c-.608-.311-1.229-.621-1.83-.921l-.664-.332-.011-.006,4.1-2.178c1.572-.835,3.2-1.7,4.8-2.552a.261.261,0,0,1,.288,0c.668.341,1.35.681,2.01,1.01l.757.378.01,0M10.442,20.541l-.07-.034L8.13,19.386q-3.5-1.748-6.994-3.5C1.02,15.833,1,15.814,1,15.721,1,13.264,1,10.766,1,8.351V6.5l.024.011.766.384c.594.3,1.208.606,1.816.9a.178.178,0,0,1,.128.2c-.006.94-.005,1.9,0,2.819v.7c0,.465.173.638.638.639l.264,0c.235,0,.479,0,.719-.006a.34.34,0,0,1,.288.126c.24.248.488.5.728.735q.212.211.422.423a.515.515,0,0,0,.922-.39c0-.834,0-1.669,0-2.521v-.67l1.706.851.232.115c.238.117.483.239.718.367a.183.183,0,0,1,.069.093c.006,3.038.005,6.127,0,9.115ZM6.714,11.663v.3l-.036-.036c-.163-.165-.317-.322-.463-.483a.789.789,0,0,0-.616-.286l-.058,0c-.205.012-.41.009-.628.006l-.165,0V8.374l.612.305.325.161c.309.153.629.311.939.475a.212.212,0,0,1,.083.107c.008.746.007,1.505.006,2.24m.593-3.234a.243.243,0,0,1-.157.021C6.631,8.2,6.108,7.937,5.6,7.682l-.277-.139L8.75,5.723c1.792-.952,3.645-1.936,5.466-2.908A.258.258,0,0,1,14.5,2.8c.462.24.92.467,1.4.708l.34.169C12.936,5.443,10.17,6.913,7.307,8.429M13.244,2.2l-2,1.065C9.016,4.451,6.717,5.673,4.458,6.88A.413.413,0,0,1,4,6.891c-.615-.32-1.228-.625-1.877-.947l-.506-.252,2.008-1c2.335-1.167,4.749-2.374,7.121-3.566a.368.368,0,0,1,.395,0c.552.287,1.1.559,1.681.847l.442.219-.024.013",
    transform: "translate(0 0)",
    fill: "#85af26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShipping);
export default __webpack_public_path__ + "static/media/icon_shipping.778592b59157d0badbe50f9e88685571.svg";
export { ForwardRef as ReactComponent };